import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryErrorBoundary"] */ "/opt/buildhome/repo/components/SentryErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
